import { make } from 'vuex-pathify';
import * as _ from 'lodash';
import total from "@/utils/getTotal";

const getDefaultState = () => {
  return {
    products: {
      airportparking: [],
      airporthotel: [],
      airportlounge: [],
      addon: []
    },
    total: 0,
    defaultAddons: [],
  }
}

// initial state
const state = getDefaultState();

const actions = {
  ...make.actions(state),
  async addToCart(context, value) {
    await context.commit('addToCart', value)
  },
  async removeCart(context, value) {
    await context.commit('removeFromCart', value)
  },
  async totalCart(context) {
    await context.commit('updateTotal')
  },
  async resetCart(context) {
    await context.commit('resetCart')
  }
};

const mutations = {
  ...make.mutations(state),
  addToCart(state, product) {

    // reset payment page error
    this.state.payment.error = '';
    
    // only allow one airport parking product in the basket
    if(product.category === 'airportparking') {

      this.state.customer.passengers = [];

      // reset terminals
      this.state.payment.travelDetails.outbound_terminal = null;
      this.state.payment.travelDetails.return_terminal = null;
      this.state.payment.travelDetails.outbound_flight = "";
      this.state.payment.travelDetails.return_flight_number = "";

      // monetary coucher applied
      let monetaryVoucher = product.promotion.monetary_discount > 0;

      // empty existing products
      Object.assign(state, getDefaultState())

      // check for default addons
      state.defaultAddons = this.state.results.products.addon.filter(a => a.addon_id === product.required_addon_id);
      
      // addon promotions 
      let promotionAddons = this.state.results.products.addon.filter(a => a.free === "1" && a.price < 1 && a.addon_id !== product.exclude_addon_id);
      if(promotionAddons.length > 0) promotionAddons.map(addon => state.products['addon'].push({ quote: this.state.quote, product: addon, quantity: 1 }))

      // global addons - booking fee etc
      let globalAddons = this.state.results.products.addon.filter(a => a.addon_type === 'default' && a.autoload === "0");
      if(globalAddons.length > 0) globalAddons.map(addon => state.products['addon'].push({ quote: this.state.quote, product: addon, quantity: 1 }))

      // push default addons into the cart
      state.defaultAddons.map(addon => state.products['addon'].push({ quote: this.state.quote, product: addon, quantity: this.state.payment.vehicles.length }))

      // check for flags that would disable multi car - param && param && param...
      let multiCarEnabled = !monetaryVoucher;

      // allow multicar
      this.state.payment.multiCar = multiCarEnabled;

      // asign meet time
      this.state.payment.travelDetails.meet_time = this.state.quote.timeA

      // assign terminals to travel details
      if(product.group_terminal && product.group_terminal.length > 0) {
        this.state.payment.travelDetails.outbound_terminal = product.group_terminal[0];
        this.state.payment.travelDetails.return_terminal = product.group_terminal[0];
      }
    }

    if(product.category === 'airporthotel') {

 
      this.state.customer.passengers = [];

      // check there is supplier data with hotel rooms
      if(product.supplier_data && product.supplier_data.hotel_rooms) {

        // check for rooms in hotel rooms object
        if(product.supplier_data.hotel_rooms.room.length > 0) {

          // filter out packages, and get rateId from room that matches initial price
          let selectedRoom = product.supplier_data.hotel_rooms.room.filter((room) => {
            //parseInt(room.price).toFixed(0) === parseInt(product.price).toFixed(0)
            return room.rateId === product.rate_id
          });
         
          if(selectedRoom[0].rateId) product.serviceCode = selectedRoom[0].rateId;
        }
      }

      // empty existing products
      Object.assign(state, getDefaultState())

      // disallow multicar
      this.state.payment.multiCar = false;
      this.state.payment.vehicles = this.state.payment.vehicles.splice(0, 1);
    }

    if(product.category === 'airportlounge' && !product.upgrade) {

      this.state.customer.passengers = [];

      // empty existing products
      Object.assign(state, getDefaultState())

      // disallow multicar
      this.state.payment.multiCar = false;
      this.state.payment.vehicles = this.state.payment.vehicles.splice(0, 1);

      // add adults/children/infants
      let passengers = ['adults', 'children', 'infants'];

      // create array of passenger numbers, 1,0,0 (adults, children, infants)
      let passengersByCat = passengers.map(cat => this.state.quote[cat]);

      passengersByCat.map((num, cat) => {

        // loop around the passenger numbers per category
        [...Array(parseInt(num))].map((_, index) => {

          const passengersForLP = {
            'adults': 'adult',
            'children': 'child',
            'infants': 'infant'
          }

          // push passanger into passenger collection
          return this.state.customer.passengers.push({ type: passengersForLP[passengers[cat]], first_name: '', last_name: '', index });
        });
      })
    }

    // push new product to state
    state.products[product.category].push({ 
      quote: this.state.quote, 
      product
    });

    // as a precaution we then check and remove duplicates
    this.state.cart.products[product.category] = _.uniqBy(state.products[product.category], 'product.product_id');

    // set basket total value
    this.state.cart.total = total(this.state.cart, this.state.payment);
  },
  removeFromCart(state, product) {

    // remove item from the cart
    let cart = _.remove(state.products[product.category], item => item.product.product_id !== product.product_id);

    // push the new array back to state with the removed item taken out
    state.products[product.category] = cart;

    // set basket total value
    this.state.cart.total = total(this.state.cart, this.state.payment);
  },
  updateDefaultAddons(state) {
    this.state.cart.products['addon'].map(addon => {

      // find index of addon in default addon collection
      let index = _.findIndex(state.defaultAddons, (o) =>  _.isMatch(o, addon.product));

      // return if we can't find any default addons to alter 
      if(index === -1) return 

      // find the default addon in the cart so we can alter the quantity
      const addonIndex = this.state.cart.products['addon'].findIndex(e => e.product.addon_id == state.defaultAddons[index].addon_id);

      // if the addon exists in the default addons collection, then multiply its quantity by vehicles
      this.state.cart.products['addon'][addonIndex].quantity = this.state.payment.vehicles.length;
    })
    this.state.cart.total = total(this.state.cart, this.state.payment);
  },
  resetCart() {
    this.state.cart = getDefaultState();
  },
  updateTotal() {
    this.state.cart.total = total(this.state.cart, this.state.payment);
  }
};

const getters = {
  ...make.getters(state),
  title(state) {
    if (state.products.airportparking.length > 0) return state.products.airportparking[0].product.park_name;
    if (state.products.airporthotel.length > 0) return state.products.airporthotel[0].product.product_name;
    if (state.products.airportlounge.length > 0) return state.products.airportlounge[0].product.product_name;
    return "";
  },
  emptyCart(state) {
    return (
      state.products.airportparking.length < 1 &&
      state.products.airporthotel.length < 1 &&
      state.products.airportlounge.length < 1
    );
  }
}

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};